import React from "react";

const CustomLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37.07 37.07"
    {...props} // allows passing props like width, height, className, etc.
  >
    <path
      fill="#1534cc"
      d="M36.95,4.17c-.67,2.46-7.5,27.52-8.31,30.47-.81,2.95-4.87,3.3-6.16.53-1.29-2.77-2.29-9.75-6.57-14.03-4.27-4.28-11.24-5.28-14.01-6.59-2.78-1.3-2.42-5.36.54-6.16C5.38,7.59,30.44.79,32.9.12c2.46-.67,4.72,1.59,4.04,4.05Z"
    />
  </svg>
);

export default CustomLogo;
